/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-checks[_ngcontent-%COMP%]{padding-left:3vh!important;padding:1vh;margin-left:18%;margin-right:18%}"];
export { styles as styles };
